import React from 'react';
import Logo from '../../../assets/logo.svg';

const QuizResolvingLoader = () => (
  <div
    className="t-h-[100dvh] t-flex t-flex-col t-bg-surface t-font-sans t-text-navy t-overflow-hidden"
    style={{ WebkitFontSmoothing: 'antialiased' }}
  >
    <div className="t-z-[100] t-bg-surface t-border-b t-border-g200">
      <div className="t-w-full t-max-w-[1260px] t-mx-auto t-px-4 lg:t-px-8 t-h-[52px] t-flex t-items-center t-justify-between">
        <div className="t-flex-1" />
        <img src={Logo} alt="riise" className="t-h-12 t-w-auto" />
        <div className="t-flex-1" />
      </div>
    </div>
    <div className="t-flex t-flex-1 t-items-center t-justify-center t-px-5">
      <div className="t-flex t-gap-1.5" aria-label="Loading quiz">
        {[0, 1, 2].map((item) => (
          <span
            key={item}
            className="t-inline-block t-w-1.5 t-h-1.5 t-rounded-full t-bg-navy/40 t-animate-bounce"
            style={{ animationDelay: `${item * 150}ms` }}
          />
        ))}
      </div>
    </div>
  </div>
);

export default QuizResolvingLoader;
